// ─── GLOBAL STYLES ────────────────────────────────────────────────────────────
export const GS = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');

    /* ── Light mode variables (default) ── */
    :root {
      --vg-bg:             #f0f2f5;
      --vg-sidebar:        #ffffff;
      --vg-card:           #ffffff;
      --vg-hover:          #f3f4f6;
      --vg-card-hover:     #f9fafb;

      --vg-primary:        #2563eb;
      --vg-primary-hover:  #1d4ed8;
      --vg-primary-light:  #eff6ff;
      --vg-primary-border: #bfdbfe;

      --vg-text:           #111827;
      --vg-text-mid:       #374151;
      --vg-text-muted:     #6b7280;
      --vg-text-light:     #9ca3af;

      --vg-border:         #e5e7eb;
      --vg-border-light:   #f3f4f6;

      --vg-shadow:         0 1px 3px rgba(0,0,0,0.07), 0 1px 2px rgba(0,0,0,0.04);
      --vg-shadow-md:      0 4px 12px rgba(0,0,0,0.08);
      --vg-shadow-lg:      0 10px 40px rgba(0,0,0,0.12);

      --vg-danger:         #ef4444;
      --vg-danger-light:   #fef2f2;
      --vg-danger-border:  #fecaca;
      --vg-danger-text:    #dc2626;

      --vg-success:        #22c55e;
      --vg-success-light:  #f0fdf4;
      --vg-success-border: #bbf7d0;
      --vg-success-text:   #15803d;

      --vg-warning:        #f59e0b;
      --vg-warning-light:  #fffbeb;
    }

    /* ── Dark mode variables ── */
    [data-theme="dark"] {
      --vg-bg:             #0f172a;
      --vg-sidebar:        #1e293b;
      --vg-card:           #1e293b;
      --vg-hover:          #334155;
      --vg-card-hover:     #243347;

      --vg-primary:        #3b82f6;
      --vg-primary-hover:  #2563eb;
      --vg-primary-light:  #172554;
      --vg-primary-border: #1e40af;

      --vg-text:           #f1f5f9;
      --vg-text-mid:       #cbd5e1;
      --vg-text-muted:     #94a3b8;
      --vg-text-light:     #64748b;

      --vg-border:         #334155;
      --vg-border-light:   #243040;

      --vg-shadow:         0 1px 3px rgba(0,0,0,0.4), 0 1px 2px rgba(0,0,0,0.3);
      --vg-shadow-md:      0 4px 12px rgba(0,0,0,0.4);
      --vg-shadow-lg:      0 10px 40px rgba(0,0,0,0.5);

      --vg-danger:         #f87171;
      --vg-danger-light:   #450a0a;
      --vg-danger-border:  #991b1b;
      --vg-danger-text:    #f87171;

      --vg-success:        #4ade80;
      --vg-success-light:  #052e16;
      --vg-success-border: #166534;
      --vg-success-text:   #4ade80;

      --vg-warning:        #fbbf24;
      --vg-warning-light:  #1c1402;
    }

    *{box-sizing:border-box;margin:0;padding:0;}
    body{font-family:'Inter',system-ui,sans-serif;background:var(--vg-bg);}
    ::-webkit-scrollbar{width:5px;height:5px;}
    ::-webkit-scrollbar-track{background:transparent;}
    ::-webkit-scrollbar-thumb{background:var(--vg-border);border-radius:4px;}
    input,select,textarea,button{font-family:'Inter',system-ui,sans-serif;}
    input::placeholder,textarea::placeholder{color:var(--vg-text-light);}
    select option{background:var(--vg-card);color:var(--vg-text);}
    @keyframes fadeIn{from{opacity:0}to{opacity:1}}
    @keyframes slideUp{from{opacity:0;transform:translateY(16px)}to{opacity:1;transform:translateY(0)}}
    @keyframes spin{to{transform:rotate(360deg)}}
    @keyframes slideUp{from{opacity:0;transform:translateY(16px)}to{opacity:1;transform:translateY(0)}}
    @keyframes pulse{0%,100%{opacity:1}50%{opacity:0.4}}
    @keyframes slideInLeft{from{transform:translateX(-100%)}to{transform:translateX(0)}}
    body.drawer-open{overflow:hidden;}
    .nav-btn:hover{background:var(--vg-hover)!important;}
    .nav-btn.active{background:var(--vg-primary)!important;color:#fff!important;}
    .nav-btn.active:hover{background:var(--vg-primary-hover)!important;}
    .card-row:hover{background:var(--vg-card-hover)!important;}
    .card-hover:hover{box-shadow:var(--vg-shadow-md)!important;border-color:var(--vg-primary-border)!important;}
    .btn-ghost:hover{background:var(--vg-hover)!important;}
    .icon-btn:hover{background:var(--vg-hover)!important;}
  `}</style>
);
